import {fetchData} from '../../utils';
import {makeSign} from '@baidu/map-fe-utils';
import {Toast} from '@baidu/onemap-design';
import superAgent from 'superagent';

export default {
    namespaced: true,

    state: {
        // 标题
        guideTitle: '',
        // 内容信息
        guideMessage: '',
        // 取消订阅按钮
        guideCancelText: '',
        // 确认订阅按钮
        guideConfirmText: '',
        // 按钮信息
        guideActionList: [],
        // 是否符合引导条件
        isAccordGuide: false
    },

    getters: {
        guideTitle: state => state.guideTitle,
        guideMessage: state => state.guideMessage,
        guideCancelText: state => state.guideCancelText,
        guideConfirmText: state => state.guideConfirmText,
        guideActionList: state => state.guideActionList,
        isAccordGuide: state => state.isAccordGuide
    },

    mutations: {
        setGuideTitle(state, params) {
            state.guideTitle = params;
        },
        setGuideMessage(state, params) {
            state.guideMessage = params;
        },
        setGuideCancelText(state, params) {
            state.guideCancelText = params;
        },
        setGuideConfirmText(state, params) {
            state.guideConfirmText = params;
        },
        setGuideActionList(state, params) {
            state.guideActionList = params;
        },
        setIsAccordGuide(state, params) {
            state.isAccordGuide = params;
        }
    },

    actions: {
        // 获取订阅信息
        getSubscribeInfo({commit, rootState}) {
            const {os = '', sv = '', cuid = ''} = rootState.phoneInfo;
            const {push_recall_key = '', source = ''} = rootState.url.urlParams;
            // 获取上次打开订阅弹窗的时间
            const lastSubscribe = JSON.parse(localStorage.getItem('lastSubscribe')) || {};
            const lastTime = lastSubscribe[push_recall_key];
            // 如果现在距离上次订阅时间小于7天，不弹订阅弹窗
            if (lastTime && (Date.now() - lastTime < 7 * 24 * 60 * 60 * 1000)) {
                return;
            }
            const url = '/usermsgcenter/subscribe/get';
            let params = {
                cuid,
                sv,
                os,
                business: push_recall_key,
                from: source
            };
            let encodeParams = {};
            Object.keys(params).forEach(key => {
                encodeParams[key] = encodeURIComponent(params[key]);
            });
            const salt = '99754106633f94d350db34d548d6091a';
            const sign = makeSign(encodeParams, salt);
            params = {
                ...params,
                sign
            };
            return fetchData(url, {
                method: 'get',
                params
            }).then(res => {
                const {status, data} = res;
                if (status === 2000) {
                    const {sub_res, is_pop_up, title = '', sub_title = '', action_list = []} = data;
                    // sub_res 1已订阅 2关闭订阅 -1/0未订阅
                    if (sub_res > 0 || !is_pop_up) {
                        // 已订阅/关闭订阅 | 不符合的push业务
                        return;
                    }
                    commit('setGuideTitle', title);
                    commit('setGuideMessage', sub_title);
                    commit('setGuideActionList', action_list);
                    action_list.forEach(item => {
                        if (item.action === 0) {
                            commit('setGuideCancelText', item.title);
                        }
                        else if (item.action === 1) {
                            commit('setGuideConfirmText', item.title);
                        }
                    });
                    commit('setIsAccordGuide', true);
                }
            });
        },
        // 设置订阅
        sendSubscribeInfo({rootState}, subStatus) {
            const url = '/usermsgcenter/subscribe/set';
            const {os = '', sv = '', cuid = ''} = rootState.phoneInfo;
            const {push_recall_key = '', source = ''} = rootState.url.urlParams;
            let params = {
                cuid,
                sv,
                os,
                business: push_recall_key,
                sub_status: subStatus,
                from: source
            };
            let encodeParams = {};
            Object.keys(params).forEach(key => {
                encodeParams[key] = encodeURIComponent(params[key]);
            });
            const salt = '99754106633f94d350db34d548d6091a';
            const sign = makeSign(encodeParams, salt);
            params = {
                ...params,
                sign
            };
            return superAgent
                .post(url)
                .set('Access-Control-Allow-Origin', '*')
                .set('Content-Type', 'application/x-www-form-urlencoded')
                .send(params)
                .then(res => {
                    const {status} = res.body;
                    if (status === 2000) {
                        Toast({
                            message: '订阅成功',
                            duration: 3000
                        });
                        // 订阅成功，清除本地存储
                        const lastSubscribe = JSON.parse(localStorage.getItem('lastSubscribe')) || {};
                        // 删除当前业务对应的订阅时间
                        delete lastSubscribe[push_recall_key];
                        if (Object.keys(lastSubscribe).length === 0) {
                            localStorage.removeItem('lastSubscribe');
                        }
                        else {
                            localStorage.setItem('lastSubscribe', JSON.stringify(lastSubscribe));
                        }
                    }
                });
        }
    }
};